import { useCallback } from 'react';
import { generatePath, useHistory, useParams } from 'react-router';
import { BulkRetargetingRoutes } from 'sections/bulk-retargeting-campaigns/routes';

export const useNavigateToScheduling = () => {
  const history = useHistory();
  const { siteId, campaignId } = useParams<{ siteId: string; campaignId: string }>();

  return useCallback(() => {
    history.push(generatePath(BulkRetargetingRoutes.EDIT_SCHEDULING, { siteId, campaignId }));
  }, [campaignId, history, siteId]);
};
